export default "/assets/images/mila-opened-door-filter-boxes.webp?01226ce077a9f10d8c1b4d1f1b405894";